import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {
	MobileDataList,
	MobileListCard,
	MobileListCardHeader,
	MobileListDetailRow,
} from '../../../Components/MobileDataList';

const OrganizationListCard = ({ organization, onEdit }) => (
	<MobileListCard>
		<Stack spacing={1.5}>
			<MobileListCardHeader
				title={organization.name}
				subtitle={organization.slug}
			/>

			<Stack spacing={1}>
				<MobileListDetailRow
					label="Invoice payee"
					value={organization.invoice_payee}
				/>
				<MobileListDetailRow
					label="From email"
					value={organization.from_email}
				/>
			</Stack>

			<Stack direction="row" spacing={0.5} justifyContent="flex-end">
				<Tooltip title="Edit">
					<IconButton size="small" onClick={() => onEdit(organization)}>
						<EditIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			</Stack>
		</Stack>
	</MobileListCard>
);

const OrganizationsMobileList = ({ organizations, isLoading, onEdit }) => (
	<MobileDataList
		items={organizations}
		isLoading={isLoading}
		getKey={(organization) => organization.id}
		emptyTitle="No organizations yet"
		emptyDescription="Create an organization to get started."
		renderItem={(organization) => (
			<OrganizationListCard organization={organization} onEdit={onEdit} />
		)}
	/>
);

export default OrganizationsMobileList;
